import { getLocale } from "../runtime";

const sv_productusp2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Leverans 1-2 arbetsdagar`
};

const productusp2 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_productusp2(inputs)
	return "productUsp2";
};

export { productusp2 as "productUsp2" };